import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Loader from "react-loader-spinner";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  ResponsiveContainer,
} from "recharts";
// import { getRandomInt } from '../../api/api';

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
const renderCustomizedLabel = (props) => {
  const { x, y, width, value } = props;
  const radius = 10;

  return (
    <g>
      {/* <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#8884d8" /> */}
      <text
        x={x + width / 2}
        y={y - radius}
        fill="#fff"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {value.split(" ")[1]}
      </text>
    </g>
  );
};

const BarCharts = (props) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, [5000]);
  }, []);

  if (props.info) {
    if (loading) {
      return (
        <div className="center" style={{ textAlign: "center" }}>
          <Loader type="TailSpin" color="#15b4de" height={300} width={"10%"} />
        </div>
      );
    } else {
      return (
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={props.info}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="0" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="1" name="Embeds" fill="#8884d8" minPointSize={5}>
                <LabelList dataKey="0" content={renderCustomizedLabel} />
              </Bar>
              <Bar dataKey="2" name="Plays" fill="#0088FE" minPointSize={10} />
              <Bar
                dataKey="3"
                name="Ad Impressions"
                fill="#00C49F"
                minPointSize={10}
              />
              <Bar
                dataKey="4"
                name="Completes"
                fill="#FFBB28"
                minPointSize={10}
              />
              <Bar
                dataKey="5"
                name="Complete Rate"
                fill="#FF8042"
                minPointSize={10}
              />
              <Bar
                dataKey="6"
                name="Time Watched"
                fill="#FF8095"
                minPointSize={10}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      );
    }
  } else {
    if (loading) {
      return (
        <div className="center" style={{ textAlign: "center" }}>
          <Loader type="TailSpin" color="#15b4de" height={300} width={"10%"} />
        </div>
      );
    } else {
      return (
        <div
          className="text-center"
          style={{ height: 300, display: "grid", placeItems: "center" }}
        >
          <h5 className="text-white">No Daily Summary</h5>
        </div>
      );
    }
  }
};

export default BarCharts;
